import styled from "styled-components";
import { WidgetStyle } from "../widgetStyle";

export const CommunityWidgetStyle = styled(WidgetStyle)``;
